export const getSize = (size: number): { width: string; height: string } => ({
  height: `${size}px`,
  width: `${size}px`,
});
